<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between"
            *ngIf="globals.checkUserHasPermission('USERS - CREATE')">
            <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/user/create-user"><i class="fas fa-user-plus">
                </i>{{"CREATE" | translate | titlecase }}</button>
        </div>

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{"USERS_MANAGEMENT" | translate | titlecase }}</h5>

                <app-loader [show]="showLoader"></app-loader>

                <!-- server search  -->
                <form class="server-search-table p-3" [formGroup]="emailForm" (submit)="getUserByName()">
                    <div class="form-group">
                        <input type="text" class="form-control"
                            placeholder="{{'SEARCH_OR_CLICK_TO_LIST_ALL' | translate | titlecase }}"
                            formControlName="email">
                        <button type="submit" class="btn-search-table">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </form>

                <app-loader [show]="searching"></app-loader>

                <div class="table-responsive py-3" style="padding: 1rem!important">
                    <table *ngIf="usersSearch != null" class="table-striped" class="table" id="datatable">
                        <thead>
                            <tr>
                                <th>{{"USER_NAME" | translate | titlecase }}</th>
                                <th>{{"TYPE" | translate | titlecase }}</th>
                                <th>{{"EMAIL" | translate | titlecase }}</th>
                                <th>{{"DISPLAY_NAME" | translate | titlecase }}</th>
                                <th>{{"MOBILE" | translate | titlecase }}</th>
                                <th>{{"ACTIVE" | translate | titlecase }}</th>
                                <!-- <th>{{"ORGANIZATION" | translate | titlecase }}</th> -->
                                <!-- <th>{{"ROLE" | translate | titlecase }}</th> -->
                                <th data-priority="1" class="border-1" class="border-0 font-14 px-2 text-grey"
                                    *ngIf="globals.checkUserHasPermission('USERS - UPDATE')"></th>
                                <!-- <th data-priority="1" class="border-1" class="border-0 font-14 px-2 text-grey"
                                *ngIf="globals.checkUserHasPermission('USERS - UPDATE') || globals.checkUserHasPermission('USERS - DELETE') "></th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of usersSearch">
                                <td class="cursor-pointer">{{res.username}}</td>
                                <td class="cursor-pointer"> {{res.userType}}</td>
                                <td class="cursor-pointer"> {{res.email}}</td>
                                <td class="cursor-pointer">{{res.displayName}}</td>
                                <td class="cursor-pointer">{{res.mobile}}</td>
                                <td class="cursor-pointer">
                                    <span class="status" [class.deactivated]="res.active != 'YES'">
                                        {{res.active}}
                                    </span>

                                </td>
                                <!-- <td class="cursor-pointer">{{res.organization}}</td> -->
                                <!-- <td class="cursor-pointer">{{res.role}}</td> -->
                                <td class="cursor-pointer text-bold text-warning"
                                    *ngIf="globals.checkUserHasPermission('USERS - UPDATE')">
                                    <button class="btn btn-sm btn-link text-warning" type="button"
                                        (click)="editUser(res.username)"
                                        *ngIf="globals.checkUserHasPermission('USERS - UPDATE') ">
                                        <i class="fas fa-edit"></i>{{"EDIT" | translate | titlecase }}
                                    </button>
                                </td>
                                <!-- Old Menu -->
                                <!-- <td class="text-end" *ngIf="globals.checkUserHasPermission('USERS - UPDATE') || globals.checkUserHasPermission('USERS - DELETE') ">
                                    <div class="dropdown">
                                        <button class="btn btn-link btn-sm dropdown-toggle" type="button"
                                            id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                            <button class="dropdown-item  btn-sm" type="button"
                                                (click)="userDelete(res.id)" *ngIf="globals.checkUserHasPermission('USERS - UPDATE') ">
                                                <i class="fas fa-trash-alt"></i>{{"DELETE" | translate | titlecase }}
                                            </button>
                                            <button class="dropdown-item  btn-sm" type="button"
                                                (click)="editUser(res.username)" *ngIf="globals.checkUserHasPermission('USERS - UPDATE') ">
                                                <i class="fas fa-pen"></i> {{"EDIT" | translate | titlecase }}
                                            </button>
                                        </div>
                                    </div>
                                </td> -->

                            </tr>
                        </tbody>
                    </table>

                    <!-- server footer 
                    <div class="d-flex justify-content-between flex-wrap p-3">
                        <div>
                            <b>Showing</b> {{currentIndex * pageLength + 1}} - {{usersSearch.length + currentIndex *
                            pageLength}}
                            <b>of</b>
                            {{totalRecords}}
                        </div>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination pagination-sm flex-wrap">
                                <li class="page-item rounded-0">
                                    <a class="page-link border-0" (click)="getNewData(currentIndex - 1)"
                                        [class.disabled]="currentIndex == 0">Previous</a>
                                </li>
                                <li class="page-item rounded-0" [class.active]="currentIndex == i"
                                    *ngFor="let page of paging;let i=index">
                                    <a class="page-link border-0 " (click)="getNewData(i)">{{i+1}}</a>
                                </li>
                                <li class="page-item rounded-0">
                                    <a class="page-link border-0" (click)="getNewData(currentIndex + 1)"
                                        [class.disabled]="currentIndex == paging.length - 1">Next</a>
                                </li>
                            </ul>
                        </nav>
                    </div> -->

                </div>
            </div>
        </div>
    </div>
</div>